import React, {useRef} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import BodySwipable from "../../visComponents/navigation/desktop/bodySwipable";
import MaterialsWizardFooterStep from "./materialsWizardFooterStep";
import {
  getWizardStepIsDisabled
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {wizardItemInterface} from "../../../interfaces/wizardItemInterface";
import {getNextWizardSteps} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";

// const stepWidth = 92;
const MaterialsWizardFooterSteps = (props) => {

  const {wizardItem, wizardSelectedValues, wizardActiveStep, isShoppingCart, showAdvancedQuoting} = props;

  const scrollElementRef = useRef();

  // const stepWidth = isMobile ? 92 : 92;

  const wizardSteps = getNextWizardSteps(wizardItem, wizardActiveStep, wizardSelectedValues);
  // console.log("wizardSteps", wizardSteps);

  // const styles = {
  //   width: (wizardSteps.length + (isShoppingCart ? 1 : 0)) * stepWidth
  // }

  // const currentGroups = getCurrentGroups(wizardItem, wizardActiveStep, wizardSelectedValues);
  // const isCompletedStep = wizardActiveStep > -1 && !currentGroups.length;
  // const menuWidth = windowWidth * 35 / 100; // 35% of screen
  // const useContainerOverFlow = styles.width >menuWidth;

  const content = (
    <div className="selection-footer-list"
         ref={scrollElementRef}
      // ref={footerList}
    >
      {wizardSteps.map((step) => {
        const stepDisabled = getWizardStepIsDisabled(step.stepIndex, wizardSelectedValues, wizardSteps);
        if (showAdvancedQuoting && (step.stepIndex !== wizardActiveStep) && window.location.href.includes("materials")) {
          return null
        }
        return <MaterialsWizardFooterStep wizardSelectedValue={wizardSelectedValues[step.stepIndex]}
                                          wizardItem={wizardItem}
                                          isShoppingCart={isShoppingCart}
                                          stepDisabled={stepDisabled}
                                          stepGroups={step.stepGroups}
                                          stepIndex={step.stepIndex}
                                          key={"wizValue" + step.stepIndex}/>
      })}
    </div>
  )

  // return useContainerOverFlow ? (
  //   <BodySwipable className="selection-footer-cell" scrollableSelector={".selection-footer-list"}>
  //     {/*<div className="selection-footer-cell__shadow selection-footer-cell__shadow--left"*/}
  //     {/*     style={{ left: this.state.shadowLeft }}/>*/}
  //     {content}
  //   </BodySwipable>
  // ) : <div className="selection-footer-cell">{content}</div>

  return (
    <BodySwipable className="selection-footer-cell" scrollableSelector={".selection-footer-list"} scrollableRef={scrollElementRef}>
      {content}
    </BodySwipable>
  )

};

MaterialsWizardFooterSteps.propTypes = {
  isShoppingCart: PropTypes.bool,
  wizardItem: PropTypes.shape(wizardItemInterface).isRequired,
  wizardValues: PropTypes.object,
  wizardStep: PropTypes.number,
}

const mapStateToProps = (store, ownProps) => {
  const {wizardSelectedValues, wizardActiveStep} = store.wizardState;
  const {windowWidth, isMobile} = store.serverState;
  const {wizardValues} = ownProps;
  const {showAdvancedQuoting} = store.advancedQuotingState;

  return {
    wizardSelectedValues: wizardValues || wizardSelectedValues,
    wizardActiveStep,
    // wizardActiveStep: Number.isInteger(wizardStep) ? wizardStep : wizardActiveStep,
    windowWidth,
    isMobile,
    showAdvancedQuoting,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialsWizardFooterSteps)
